module.exports = __webpack_public_path__ + "img/ic_check_outlined.c0579e54.svg";